/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { classes, Container } from '@adobe-commerce/elsie/lib';
import { AddressFormWrapper } from '@/account/components';
import { AddressFormProps } from '@/account/types';

export const AddressForm: Container<AddressFormProps> = ({
  hideActionFormButtons,
  formName,
  showFormLoader,
  showSaveCheckBox,
  saveCheckBoxValue,
  forwardFormRef,
  slots,
  addressesFormTitle,
  className,
  addressFormId,
  inputsDefaultValueSet,
  billingCheckBoxValue,
  shippingCheckBoxValue,
  showBillingCheckBox,
  showShippingCheckBox,
  isOpen,
  fieldIdPrefix,
  onSubmit,
  onCloseBtnClick,
  onSuccess,
  onError,
  onChange,
}) => {
  return (
    <div className={classes(['account-address-form'])}>
      <AddressFormWrapper
        hideActionFormButtons={hideActionFormButtons}
        formName={formName}
        showFormLoader={showFormLoader}
        slots={slots}
        addressesFormTitle={addressesFormTitle}
        className={className}
        addressFormId={addressFormId}
        inputsDefaultValueSet={inputsDefaultValueSet}
        shippingCheckBoxValue={shippingCheckBoxValue}
        billingCheckBoxValue={billingCheckBoxValue}
        showShippingCheckBox={showShippingCheckBox}
        showBillingCheckBox={showBillingCheckBox}
        isOpen={isOpen}
        fieldIdPrefix={fieldIdPrefix}
        onSubmit={onSubmit}
        onCloseBtnClick={onCloseBtnClick}
        onSuccess={onSuccess}
        onError={onError}
        onChange={onChange}
        forwardFormRef={forwardFormRef}
        showSaveCheckBox={showSaveCheckBox}
        saveCheckBoxValue={saveCheckBoxValue}
      />
    </div>
  );
};
